import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommandeService } from 'src/app/core/services/commande.service';
import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';
import { ReferenceDataService } from 'src/app/core/services/referencedata.service';
//import { TarifConfigurationService } from 'src/app/core/services/tarif-configuration.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { TypeArticle } from 'src/app/core/enumerateurs/type-article';
import { TypeConditionnement } from 'src/app/core/enumerateurs/type-conditionnement';
//import { resolveTxt } from 'dns';
//import { TarifConfigurationDTO } from 'src/app/shared/interfaces/dtos/tarif-configuration-dto';


@Component({
  selector: 'app-articlepopup',
  templateUrl: './articlepopup.component.html',
  styleUrls: ['./articlepopup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArticlepopupComponent implements OnInit {

  articleForm!: FormGroup;
  loading = false;
  viewBtnEnregistrer = true;

/*   typeArticles: any = [];
  typeConditionnement: any = [];
  typeCondParTypeArticle: any = []; */

  typeArticlesOptions: { label: string, value: string }[] = [];

  typeConditionnementOptions: { label: string, value: string }[] = [];

  //typeCondParTypeArticleOptions: { label: string, value: string }[] = [];

  //tarifConfigurationDTO: TarifConfigurationDTO = {};

  //formStep: number = 1;

  prixCalcule: boolean = false;

  //editingIndex: number | null = null;

  

  constructor(@Inject(MAT_DIALOG_DATA) public data: any
, private fb: FormBuilder
//, private dialog: MatDialog
, private messageService: MessageService
, private toastService: ToastService
, public commandeService: CommandeService
, public referenceDataService: ReferenceDataService
//, private tarifConfigurationService: TarifConfigurationService
, public sharedUtilsService: SharedUtilsService
, private dialogRefArticle: MatDialogRef<ArticlepopupComponent>) {


  //typeArticleOptions: { label: string, value: string }[] = [];
 }

  ngOnInit(): void {

    this.articleForm = this.fb.group({
      //cmdArtId: [null],
      //id: [0],
      typeArticle: ["", [Validators.required]],
      description: ['', Validators.required],
      prixUnitaire: [0, Validators.required],
      quantite: [1, Validators.required],
      volume: [undefined],
      dimensions: [undefined],
      longueur: [undefined],
      largeur: [undefined],
      hauteur: [undefined],
      poidsVolumetrique: [0.0],
      poidsReel: [undefined, Validators.required],
      poids: [undefined],
      poidsSupplementaire: [undefined],
      montant: [undefined],
      montantForfait: [0],
      montantSupplementaire: [0],
      valeurDeclaree: [undefined],
      typeConditionnement: ["", [Validators.required]],
      flgEmballageDematral: [undefined],
      //typeArticleLibelle: [''],
      //typeConditionnementLibelle: ['']
      commandeId: [0],
      
      lieuDepartLongitude: [this.data.lieuDepartLongitude],
      lieuDepartLatitude: [this.data.lieuDepartLatitude],
      lieuArriveeLongitude: [this.data.lieuArriveeLongitude],
      lieuArriveeLatitude: [this.data.lieuArriveeLatitude],
      trajetId: [this.data.trajetId],
      longueurDuTrajet: [this.data.longueurDuTrajet]

    });

    if(this.data.article != undefined) {
      this.typeConditionnementOptions = this.getConditionnementsByType(this.data.article.typeArticle);
      this.articleForm.patchValue(this.data.article);
      //this.articleForm.value['typeConditionnement'] = this.data.article.typeConditionnement;
    }

    this.chargerDonneesReference();

    //this.setuppoidsVolumetriqueUpdate();

    /* this.articleForm.get('typeArticle')?.valueChanges.subscribe((selectedType) => {
      this.typeConditionnementOptions = this.getConditionnementsByType(selectedType);
      this.articleForm.get('typeConditionnement')?.reset();
    }); */

    //console.log(this.data);
  }

  chargerDonneesReference() {



    this.typeArticlesOptions = this.referenceDataService.enumVersOptions(TypeArticle); 
    //this.typeConditionnementOptions = this.referenceDataService.enumToOptions(TypeConditionnement); 

    /* this.tarifConfigurationService.getTarifConfiguration().subscribe(
      (response) => {
        this.tarifConfigurationDTO = response;
      }
    ); */

}

onTypeArticleChanged(type: string) {
  this.typeConditionnementOptions = this.getConditionnementsByType(type);
  this.articleForm.get('typeConditionnement')?.reset();
}

/* 
onTypeConditionnement(tcId: MatSelectChange) {

  for(let tc of this.typeConditionnement) {
    if(tc.id == tcId.value) {
      this.articleForm.value['typeConditionnement'] = { id: tcId.value };
      this.articleForm.patchValue({ typeConditionnementLibelle: tc.libelle });
    }
  }
} */

  private getConditionnementsByType(prefix: string): { label: string; value: string }[] {
    return Object.entries(TypeConditionnement)
    .filter(([key]) => key.startsWith(prefix))
    .map(([key, value]) => ({
      label: this.referenceDataService.formaterLibelle(String(value)),
      value: key   // ✅ on met la clé enum ici
    }));
  }

  setuppoidsVolumetriqueUpdate() {
  this.articleForm.get('poids')?.valueChanges.subscribe(() => this.updatepoidsVolumetrique());
  this.articleForm.get('longueur')?.valueChanges.subscribe(() => this.updatepoidsVolumetrique());
  this.articleForm.get('largeur')?.valueChanges.subscribe(() => this.updatepoidsVolumetrique());
  this.articleForm.get('hauteur')?.valueChanges.subscribe(() => this.updatepoidsVolumetrique());
}

updatepoidsVolumetrique() {
  const longueur = this.articleForm.get('longueur')?.value || 0;
  const largeur = this.articleForm.get('largeur')?.value || 0;
  const hauteur = this.articleForm.get('hauteur')?.value || 0;

  let poidsVolumetrique = (longueur * largeur * hauteur) / 3000;

  poidsVolumetrique = this.sharedUtilsService.arrondirXtainesSuperieures(poidsVolumetrique, 1);

  //this.articleForm.get('poidsVolumetrique')?.setValue(poidsVolumetrique, { emitEvent: false });
  this.articleForm.patchValue({['poidsVolumetrique'] : poidsVolumetrique});


  //Mise à jour prix unitaire de l'article
  //this.calculatePrices();


}

onSubmit() {

  if (this.articleForm.invalid) {

    this.toastService.erreur(this.messageService.obtenirErreursValidationFormulaire(this.articleForm));
    return;
  }

  this.loading = true;

  if(this.articleForm.value['quantite'] == undefined || (this.articleForm.value['longueur'] == undefined && this.articleForm.value['largeur'] == undefined 
    && this.articleForm.value['hauteur'] == undefined && this.articleForm.value['poidsReel'] == undefined) ) {
      //alert('Erreur de Saisie du formaulaire: Vous devez saisir les dimensions du colis ou son poids');
      this.toastService.erreur('Vous devez saisir les dimensions du colis ou son poids','Erreur de Saisie du formaulaire');
      this.loading = false;
      //console.log(this.articleForm);
      return;
    }

    if(this.articleForm.value['longueur'] != undefined || this.articleForm.value['largeur'] != undefined 
      || this.articleForm.value['hauteur'] != undefined) {
        this.updatepoidsVolumetrique();
      }

      this.commandeService.calculerPrixUnitaire(this.articleForm.value).subscribe(
        (response) => {
          
        if(this.data.nbrArticle > 0) {

          if(this.data.longueurDuTrajet != response.longueurDuTrajet) {
            this.loading = false;
            this.viewBtnEnregistrer = true;
            this.toastService.erreur(this.messageService.afficherMessageErreur(
              'La longueur du trajet a été modifiée, vous devez supprimer les articles ajoutés précedement'));
              return;
          }

        }
        
        this.loading = false;
        //this.articleForm.value['typeArticleLibelle']= this.referenceDataService.obtenirLibelleDepuisValeurEnum(TypeArticle, this.articleForm.value['typeArticle']);
        //this.articleForm.value['typeConditionnementLibelle']= this.referenceDataService.obtenirLibelleDepuisValeurEnum(TypeConditionnement, this.articleForm.value['typeConditionnement']);
        this.prixCalcule = true;

        //this.articleForm.patchValue(response);
        this.articleForm.patchValue({ poids: response.poids });
        this.articleForm.patchValue({ prixUnitaire: response.prixUnitaire });
        this.articleForm.patchValue({ montantForfait: response.montantForfait })
        this.articleForm.patchValue({ poidsSupplementaire: response.poidsSupplementaire });
        this.articleForm.patchValue({ montantSupplementaire: response.montantSupplementaire });
        this.articleForm.patchValue({ montant: response.montant });
        this.articleForm.patchValue({ longueurDuTrajet: response.longueurDuTrajet });

        //this.formStep = 2;
        
        //this.dialogRefArticle.close(this.articleForm);
      },
      (error) => {
        this.loading = false;
        this.viewBtnEnregistrer = true;
        this.toastService.erreur(this.messageService.afficherMessageErreur(error));
      }
    );
}

ajouterArticle() {
    if (!this.prixCalcule) {
      this.toastService.erreur("Vous devez d'abord calculer le prix de l'article");
      return;
    }

    const longueur = parseFloat(this.articleForm.value['longueur']) || 0;
    const largeur  = parseFloat(this.articleForm.value['largeur'])  || 0;
    const hauteur  = parseFloat(this.articleForm.value['hauteur'])  || 0;

    this.articleForm.patchValue({
      longueur,
      largeur,
      hauteur,
      dimensions: `${longueur} x ${largeur}`,
      volume: longueur * largeur * hauteur
    });

    this.dialogRefArticle.close(this.articleForm);
  }

  nettoyerNombre(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const val = input.value.trim();
    if (val === '' || val === null) return;
    const parsed = parseFloat(val.replace(',', '.'));
    if (!isNaN(parsed)) {
      input.value = String(parsed);
      this.articleForm.patchValue({ [controlName]: parsed });
    }
  }

  /* openDialog(title: string, message: string): void {
    const dialogRef =  this.dialog.open(MessagepopupComponent, {
      width: '600px',
      data: { title: title, message: message }
    }); 

  }*/

    retournerLibelleDepuisClerEnum(entite: string): string {

    if(entite === 'TypeArticle') {
      return this.referenceDataService.obtenirLibelleDepuisCleEnum(TypeArticle, this.articleForm.value['typeArticle']);
    } else if(entite === 'TypeConditionnement') {
      return this.referenceDataService.obtenirLibelleDepuisCleEnum(TypeConditionnement, this.articleForm.value['typeConditionnement']);
    } else {
      return "";
    }
  }

}
